import {
  Component,
  OnInit,
  Directive,
  ElementRef,
  Input,
  HostListener
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";

export interface TableItems {
  title: string;
  Items: any;
  Cols: any;
}

@Component({
  selector: 'app-table-popup',
  templateUrl: './table-popup.component.html',
  styleUrls: ['./table-popup.component.css']
})
export class TablePopupComponent extends DialogComponent<TableItems, boolean>
  implements TableItems, OnInit {

  title: string;
  Items: any;
  Cols: any;

  result: any = { result: false, RtnItem: {} };

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {

  }
  ok() {
    this.result.result = true;
    this.result.RtnItem = this.Items;
    this.close();
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/table-popup/table-popup.component.ts